module.exports = "/src/views/player/documets/msc/images/logo.png";